module.exports = __webpack_public_path__ + "br.svg?182f9e334da7c92b4fa97c61078a96b7";